import { isNil } from 'lodash-es'
import { Fragment } from 'react'
import { Divider } from './ui/divider'
import { HStack } from './ui/hstack'
import { Pressable } from './ui/pressable'
import { Text } from './ui/text'
import { VStack } from './ui/vstack'

type StatsItemType = {
  title?: string | number | null
  description: string
  onPress?: () => void
}

type StatsGroupProps = {
  items: StatsItemType[]
  className?: string
  size?: 'default' | 'medium' | 'large'
}

export default function StatsGroup({ items, className, size = 'default' }: StatsGroupProps) {
  return (
    <HStack className={`justify-evenly items-center ${className}`}>
      {items.map((item, index) => {
        return (
          <Fragment key={index}>
            {index > 0 && <Divider orientation="vertical" className="h-3/5 bg-separator-vibrant" />}
            <StatsItem item={item} size={size} />
          </Fragment>
        )
      })}
    </HStack>
  )
}

const SIZE_MAP = {
  default: { title: 'title-2', desc: 'caption-1' },
  medium: { title: 'title-1', desc: 'footnote' },
  large: { title: 'large-title', desc: 'subhead' },
} as const

function StatsItem({ item, size }: { item: StatsItemType; size: 'default' | 'medium' | 'large' }) {
  const titleSize = SIZE_MAP[size].title
  const descSize = SIZE_MAP[size].desc
  const content = (
    <VStack space="sm" className="items-center">
      <Text size={titleSize} className="text-label">
        {!isNil(item.title) ? item.title : '-'}
      </Text>
      <Text size={descSize} className="text-secondary-label">
        {item.description}
      </Text>
    </VStack>
  )
  if (item.onPress) {
    return <Pressable onPress={item.onPress}>{content}</Pressable>
  }
  return content
}
